module.exports = __webpack_public_path__ + "static/media/logo_qualdo-mqx.48061a72.svg";